import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-advance-search',
  templateUrl: './advance-search.component.html',
  styleUrl: './advance-search.component.scss'
})
export class AdvanceSearchComponent implements OnInit {
  @Input() properties!: { placeholder?: string, width?: string }
  @Input() parentFunctionOptions!: () => void;
  @Input() parentFunctionSearch!: () => void;
  expanded = false;

  ngOnInit(): void {
    if (!this.properties.width)
      this.properties.width = "250px;"
  }
  callParentFunctionOptions() {
    this.expanded = !this.expanded;
    if (this.parentFunctionOptions) {
      this.parentFunctionOptions();
    }
  }

  callParentFunctionSearch() {
    if (this.parentFunctionSearch) {
      this.parentFunctionSearch();
    }
  }
}
